module.exports = __webpack_public_path__ + "static/media/6_l_vinil_25.99_90.28.8271cd79.png";